<div class="toolbar">
    <div class="toolbar__logo">
        <img src="../assets/images/lokOsLogo.svg" alt="menu" />
        <span class="toolbar__title">{{ 'lokos' | translate }}</span>
    </div>

    <div class="user-profile" [matMenuTriggerFor]="profileMenu">
        <img
            class="profile-img"
            [src]="'data:image/png;base64,' + userProfile?.profileImage"
            #img
            (error)="img.src = '../assets/images/profileLogo.svg'"
            alt="profile"
        />
        <div class="profile-desc">
            <span class="user-name">{{ userProfile?.name }}</span>
            <span class="user-role">{{ userProfile?.email }}</span>
        </div>
        <img class="profile-arrow" src="../assets/images/dropDownArrow.svg" alt="arrow down" />
        <mat-menu #profileMenu="matMenu" class="mat-elevation-z3">
            <lokos-profile></lokos-profile>
        </mat-menu>
    </div>
</div>
